var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageApiAccessKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6197 1.35355C11.8544 1.21548 12.1456 1.21548 12.3803 1.35355L20.8803 6.35355C21.1093 6.4883 21.25 6.73423 21.25 7V17C21.25 17.2658 21.1093 17.5117 20.8803 17.6465L12.3803 22.6465C12.1456 22.7845 11.8544 22.7845 11.6197 22.6465L3.11973 17.6465C2.89066 17.5117 2.75 17.2658 2.75 17V7C2.75 6.73423 2.89066 6.4883 3.11973 6.35355L11.6197 1.35355ZM4.25 7.42896V16.571L12 21.1299L19.75 16.571V7.42896L12 2.87014L4.25 7.42896ZM16.6335 9.10146C16.853 9.45269 16.7463 9.91541 16.395 10.135L12.75 12.4135V16.5C12.75 16.9142 12.4142 17.25 12 17.25C11.5858 17.25 11.25 16.9142 11.25 16.5V12.4176L7.60214 10.1348C7.25101 9.91504 7.1445 9.45226 7.36423 9.10114C7.58396 8.75001 8.04674 8.64349 8.39786 8.86323L11.9967 11.1154L15.6 8.86303C15.9512 8.64347 16.4139 8.75022 16.6335 9.10146Z",
    fill: "#828FAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageApiAccessKey);
export default __webpack_public_path__ + "static/media/manage-api-access-key.7428685e.svg";
export { ForwardRef as ReactComponent };